enum RecipientType {
  Company = "company",
  CompanyPerson = "companyPerson",
  Person = "person",
}

export default RecipientType;
